module.exports = __webpack_public_path__ + "img/thankyou.56fe632d.png";